// spa-entry.js — SPA 主入口（index.html 桌面壳 / index-m.html 移动壳共用）
// 职责：CSRF 注入 → 登录门禁 → 平台重定向 → Shell 初始化 → 路由分发

// Service Worker 注册（PWA 离线支持）
if ('serviceWorker' in navigator && !/localhost|127\.0\.0\.1/.test(location.hostname)) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(function(reg) {
    console.log('[PWA] Service Worker 注册成功 scope=' + reg.scope);
  }).catch(function(err) {
    console.error('[PWA] Service Worker 注册失败:', err.message);
  });
}

// 窗口宽度跨越 1024px 断点时自动刷新（桌面/移动壳切换，配合服务端双入口）
(function() {
  var BP = 1024;
  var lastIsDesktop = window.matchMedia('(min-width: ' + (BP + 1) + 'px)').matches;
  var timer = null;
  window.addEventListener('resize', function() {
    if (timer) return;
    timer = setTimeout(function() {
      timer = null;
      var isDesktop = window.matchMedia('(min-width: ' + (BP + 1) + 'px)').matches;
      if (isDesktop === lastIsDesktop) return;
      location.reload();
    }, 400);
  });
})();

import '@shared/csrf.js';
import '@shared/config.js';

import { ensureLogin } from '@lib/ensure-login.js';

import { initShell } from './shell-init.js';
import { matchRoute, loadRoute, render404, redirectPlatform } from './router.js';
import { bindChatEntry } from './chat-entry.js';
import { initPullRefresh } from './pull-refresh.js';

(async function() {
  // 登录门禁：未登录/强制改密/接口异常时已跳转，中断后续渲染（避免首页框架闪现）
  try {
    var loggedIn = await ensureLogin();
    if (!loggedIn) return;
  } catch (e) {
    console.error('登录检查失败', e);
    return;
  }

  // 平台自动重定向：workspace 路由初始加载时，按屏幕宽度加/去 -m（已跳转则中断）
  if (redirectPlatform()) {
    return;
  }

  initShell();

  // 移动端下拉刷新（整页重载）
  initPullRefresh();

  // 绑定哈密聊天入口（桌面浮窗 / 移动全屏）
  bindChatEntry();

  var route = matchRoute(location.pathname);
  if (route) {
    loadRoute(route);
  } else {
    render404();
  }
})();
